import React from 'react';
import { Grid, Typography } from '@mui/material';
import BackButton from 'components/Button';
// import Image from './caminho/para/sua-imagem.jpg'; // Importe sua imagem aqui

const styles = {
    root: {
        p: 3,
        width: '60%',
        margin: 'auto',
    },
    section: {
        mb: 4,
    },
    title: {
        mb: 2,
        fontWeight: 'bold',
    },
    content: {
        mb: 2,
    },
    backButton: {
        mt: 2,
        justifyContent: 'center',
        display: 'flex',
    },
};

const ProgramadeResistencia = () => {

    return (
        <Grid container sx={styles.root}>
            <Grid item xs={12} sx={styles.section}>
                <Typography variant="h4" sx={styles.title}>
                    Boa Prática - Campos de Júlio/MT tem programa de resistência às drogas
                </Typography>
                <Typography variant="body1" sx={styles.content}>
                    <strong>Data:</strong> Segunda, 07 de maio de 2012
                </Typography>
                <Typography variant="body1" sx={styles.content}>
                    <strong>Município:</strong> Campos de Júlio/MT
                </Typography>
            </Grid>
            <Grid item xs={12} sx={styles.section}>
                <Typography variant="h5" sx={styles.title}>
                    Iniciativa da prefeitura
                </Typography>
                <Typography variant="body1" sx={styles.content}>
                    A primeira boa ação de enfrentamento registrada no portal Observatório do Crack, lançado nesta terça-feira, 26 de abril, foi a de Campos de Júlio (MT). O Município desenvolve desde 2002 projeto de ação preventiva com os alunos da rede municipal e estadual. O trabalho foi viabilizado por meio de um termo de Cooperação Técnica e Logística entre o Programa Educacional de Resistência às Drogas e a Violência (Proerd) da Policia Militar e a secretaria de Educação, Em entrevista a Agência CNM de Notícias, a coordenadora da Secretaria de Educação, Nelsa Gouvêa Meleiro, contou que é como se fosse um curso ministrado uma vez por semana, incluído no currículo escolar, que orienta sobre os efeitos físicos e mentais causados pelo consumo de entorpecentes. E ao final do trabalho cada integrante da turma recebe um certificado de participação.
                    “Um integrante da polícia apto a desenvolver o trabalho de prevenção vai até a escola e desenvolve atividades com os alunos do quarto, quinto e sexto ano”, explicou Nelsa. O objetivo do programa é ampliar o nível de informação dos estudantes alcança os pais e o corpo docente.
                </Typography>
            </Grid>
            <Grid item xs={12} sx={styles.section}>
                <Typography variant="h5" sx={styles.title}>
                    Resultados
                </Typography>
                <Typography variant="body1" sx={styles.content}>
                    - A maioria escolas do Município foi mobilizada.
                    - Atendimento de aproximadamente 1.100 crianças e adolescentes como beneficiários diretos.
                    - Uma parcela desse público tem atendimento em tempo integral, com oferta de alimentação, higienização pessoal e transporte.
                    - Diminuição do número de vítimas de exploração do trabalho infantil.
                    - Aumento do leque de oportunidade de emprego.
                    - Encaminhamento de adolescentes usuários de drogas a centros de tratamento.
                    - Ex-alunos são empregados no projeto.
                </Typography>
            </Grid>
            <Grid item xs={12} sx={styles.section}>
                <Typography variant="h5" sx={styles.title}>
                    Recursos
                </Typography>
                <Typography variant="body1" sx={styles.content}>
                    A Funcef, bem como seus programas e projetos, é mantida pela Prefeitura Municipal de Formoso do Araguaia e por doações de empresas locais. Para somar, existem parcerias com as Secretarias de Saúde, Assistência social, Educação, Esporte, Lazer, Meio Ambiente e Turismo.
                    O valor anual para o desenvolvimento das atividades é de, aproximadamente, R$ 550 mil.
                </Typography>
            </Grid>
            <Grid item xs={12} sx={styles.backButton}>
                <BackButton />
            </Grid>
        </Grid>
    );
};

export default ProgramadeResistencia;
